import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const Home = () => import('@/views/Home')
const Four = () => import('@/views/Four')
const Seven = () => import('@/views/Seven')
const About = () => import('@/views/About')
const PortfolioCompanies = () => import('@/views/PortfolioCompanies')
const Introduced = () => import('@/components/portfolio-companies/index')
const Szpas = () => import('@/components/portfolio-companies/Szpas')
const Whzsbkj = () => import('@/components/portfolio-companies/Whzsbkj')
const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
const Consulting = () => import('@/components/consulting/index.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/about',
    component:About
  },
  {
    path:'/portfolio-companies',
    component:PortfolioCompanies,
    redirect: '/portfolio-companies/0',
    children:[
      {
        path:'0',
        component:Introduced
      },
      {
        path:'1',
        component:Szpas
      },
      {
        path:'2',
        component:Whzsbkj
      },
      {
        path:'3',
        component:EnterInnovation
      },
      {
        path:'4',
        component:Consulting
      }
    ]
  },
  {
    path:'/four',
    component: Four
  },
  {
    path:'/seven',
    component:Seven
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
